// The notification processor silently drops any email that does not match
// ^([\w\.\-]+)@([\w\-]+)((\.(\w){2,3})+)$ (no callback), and the API rejects the same
// addresses, so Confirm must stay disabled for them. Their \w is .NET's, which matches
// Unicode letters and digits (an accented name such as "jose" with an acute e passes),
// so the client spells it out: letters, combining marks, decimal digits and connector
// punctuation (underscore). Note the rule rejects "+" addressing and any domain part
// after the first dot that is not 2 or 3 characters long.
const W = String.raw`\p{L}\p{Mn}\p{Nd}\p{Pc}`;
const PROCESSOR_EMAIL_PATTERN = new RegExp(
    String.raw`^([${W}.-]+)@([${W}-]+)((\.([${W}]){2,3})+)$`,
    'u'
);
// Anything shaped like an address; used to tell a finished-looking address the
// processor would refuse from one that is still being typed.
const LOOSE_EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const MAX_EMAIL_LENGTH = 254;

export function isValidEmail(value: string | null | undefined): boolean {
    const email = (value ?? '').trim();
    return (
        email.length <= MAX_EMAIL_LENGTH && PROCESSOR_EMAIL_PATTERN.test(email)
    );
}

// An address that looks complete but would be rejected, as opposed to one that is
// merely unfinished ("john@gma"), or one that is simply too long. Only these get the
// inline hint.
export function isUnsupportedEmail(value: string | null | undefined): boolean {
    const email = (value ?? '').trim();
    if (email.length > MAX_EMAIL_LENGTH) {
        return true;
    }
    return (
        LOOSE_EMAIL_PATTERN.test(email) && !PROCESSOR_EMAIL_PATTERN.test(email)
    );
}

// fbx-input's tel mask only ever produces a US number, "(555) 555-5555". An area code
// never starts with 0 or 1 in the North American numbering plan.
export function isValidUsPhone(value: string | null | undefined): boolean {
    return /^[2-9]\d{9}$/.test((value ?? '').replace(/\D/g, ''));
}

// The backend takes E.164, not the masked display value.
export function toE164UsPhone(value: string): string {
    return `+1${value.replace(/\D/g, '')}`;
}
